"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadChallenge = function loadChallenge(params) {
  return {
    type: 'OLY_LOAD_CHALLENGE',
    payload: _objectSpread({}, params)
  };
};

var loadChallengeSuccess = function loadChallengeSuccess(data) {
  return {
    type: 'OLY_LOAD_CHALLENGE_SUCCESS',
    payload: {
      data: data
    }
  };
};

var loadChallengeError = function loadChallengeError() {
  return {
    type: 'OLY_LOAD_CHALLENGE_ERROR'
  };
};

var resetChallenge = function resetChallenge() {
  return {
    type: 'OLY_RESET_CHALLENGE'
  };
};

var loadChallengeStats = function loadChallengeStats(params) {
  return {
    type: 'OLY_LOAD_CHALLENGE_STATS',
    payload: _objectSpread({}, params)
  };
};

var loadChallengeStatsSuccess = function loadChallengeStatsSuccess(data) {
  return {
    type: 'OLY_LOAD_CHALLENGE_STATS_SUCCESS',
    payload: {
      data: data
    }
  };
};

var loadChallengeStatsError = function loadChallengeStatsError() {
  return {
    type: 'OLY_LOAD_CHALLENGE_STATS_ERROR'
  };
};

var resetChallengeStats = function resetChallengeStats() {
  return {
    type: 'OLY_RESET_CHALLENGE_STATS'
  };
};

var challengeRegister = function challengeRegister(params) {
  return {
    type: 'OLY_REGISTER_CHALLENGE',
    payload: _objectSpread({}, params)
  };
};

var challengeRegisterSuccess = function challengeRegisterSuccess() {
  return {
    type: 'OLY_REGISTER_CHALLENGE_SUCCESS'
  };
};

var challengeRegisterError = function challengeRegisterError(params) {
  return {
    type: 'OLY_REGISTER_CHALLENGE_ERROR',
    payload: _objectSpread({}, params)
  };
};

var resetChallengeRegister = function resetChallengeRegister() {
  return {
    type: 'OLY_RESET_CHALLENGE_REGISTER'
  };
};

var loadUserChallenge = function loadUserChallenge(params) {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE',
    payload: _objectSpread({}, params)
  };
};

var loadUserChallengeSuccess = function loadUserChallengeSuccess(data) {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_SUCCESS',
    payload: {
      data: data
    }
  };
};

var loadUserChallengeError = function loadUserChallengeError() {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ERROR'
  };
};

var resetUserChallenge = function resetUserChallenge() {
  return {
    type: 'OLY_RESET_USER_CHALLENGE'
  };
};

var loadUserGroupChallenge = function loadUserGroupChallenge(params) {
  return {
    type: 'OLY_LOAD_USER_GROUP_CHALLENGE',
    payload: _objectSpread({}, params)
  };
};

var loadUserGroupChallengeSuccess = function loadUserGroupChallengeSuccess(data) {
  return {
    type: 'OLY_LOAD_USER_GROUP_CHALLENGE_SUCCESS',
    payload: {
      data: data
    }
  };
};

var loadUserGroupChallengeError = function loadUserGroupChallengeError() {
  return {
    type: 'OLY_LOAD_USER_GROUP_CHALLENGE_ERROR'
  };
};

var setUserGroupChallenge = function setUserGroupChallenge(data) {
  return {
    type: 'OLY_LOAD_SET_USER_GROUP_CHALLENGE',
    payload: {
      data: data
    }
  };
};

var resetUserGroupChallenge = function resetUserGroupChallenge() {
  return {
    type: 'OLY_RESET_USER_GROUP_CHALLENGE'
  };
};

var updateUserChallenge = function updateUserChallenge(params) {
  return {
    type: 'OLY_UPDATE_USER_CHALLENGE',
    payload: _objectSpread({}, params)
  };
};

var updateUserChallengeSuccess = function updateUserChallengeSuccess() {
  return {
    type: 'OLY_UPDATE_USER_CHALLENGE_SUCCESS'
  };
};

var updateUserChallengeError = function updateUserChallengeError() {
  return {
    type: 'OLY_UPDATE_USER_CHALLENGE_ERROR'
  };
};

var loadUserChallengeActivities = function loadUserChallengeActivities(params) {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ACTIVITIES',
    payload: _objectSpread({}, params)
  };
};

var loadUserChallengeActivitiesSuccess = function loadUserChallengeActivitiesSuccess(data) {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ACTIVITIES_SUCCESS',
    payload: _objectSpread({}, data)
  };
};

var loadUserChallengeActivitiesError = function loadUserChallengeActivitiesError() {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ACTIVITIES_ERROR'
  };
};

var resetUserChallengeActivities = function resetUserChallengeActivities() {
  return {
    type: 'OLY_RESET_USER_CHALLENGE_ACTIVITIES'
  };
};

var loadUserChallengeActions = function loadUserChallengeActions(params) {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ACTIONS',
    payload: _objectSpread({}, params)
  };
};

var loadUserChallengeActionsSuccess = function loadUserChallengeActionsSuccess(data) {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ACTIONS_SUCCESS',
    payload: _objectSpread({}, data)
  };
};

var loadUserChallengeActionsError = function loadUserChallengeActionsError() {
  return {
    type: 'OLY_LOAD_USER_CHALLENGE_ACTIONS_ERROR'
  };
};

var resetUserChallengeActions = function resetUserChallengeActions() {
  return {
    type: 'OLY_RESET_USER_CHALLENGE_ACTIONS'
  };
};

var loadUserGroupChallengeStats = function loadUserGroupChallengeStats(params) {
  return {
    type: 'OLY_LOAD_USER_GROUP_CHALLENGE_STATS',
    payload: _objectSpread({}, params)
  };
};

var loadUserGroupChallengeStatsSuccess = function loadUserGroupChallengeStatsSuccess(data) {
  return {
    type: 'OLY_LOAD_USER_GROUP_CHALLENGE_STATS_SUCCESS',
    payload: {
      data: data
    }
  };
};

var loadUserGroupChallengeStatsError = function loadUserGroupChallengeStatsError() {
  return {
    type: 'OLY_LOAD_USER_GROUP_CHALLENGE_STATS_ERROR'
  };
};

var resetUserGroupChallengeStats = function resetUserGroupChallengeStats() {
  return {
    type: 'OLY_RESET_USER_GROUP_CHALLENGE_STATS'
  };
};

var _default = {
  loadChallenge: loadChallenge,
  loadChallengeError: loadChallengeError,
  loadChallengeSuccess: loadChallengeSuccess,
  resetChallenge: resetChallenge,
  loadChallengeStats: loadChallengeStats,
  loadChallengeStatsError: loadChallengeStatsError,
  loadChallengeStatsSuccess: loadChallengeStatsSuccess,
  resetChallengeStats: resetChallengeStats,
  challengeRegister: challengeRegister,
  challengeRegisterSuccess: challengeRegisterSuccess,
  challengeRegisterError: challengeRegisterError,
  resetChallengeRegister: resetChallengeRegister,
  loadUserChallenge: loadUserChallenge,
  loadUserChallengeSuccess: loadUserChallengeSuccess,
  loadUserChallengeError: loadUserChallengeError,
  loadUserGroupChallenge: loadUserGroupChallenge,
  loadUserGroupChallengeSuccess: loadUserGroupChallengeSuccess,
  loadUserGroupChallengeError: loadUserGroupChallengeError,
  setUserGroupChallenge: setUserGroupChallenge,
  resetUserGroupChallenge: resetUserGroupChallenge,
  updateUserChallenge: updateUserChallenge,
  updateUserChallengeSuccess: updateUserChallengeSuccess,
  updateUserChallengeError: updateUserChallengeError,
  resetUserChallenge: resetUserChallenge,
  loadUserChallengeActivities: loadUserChallengeActivities,
  loadUserChallengeActivitiesSuccess: loadUserChallengeActivitiesSuccess,
  loadUserChallengeActivitiesError: loadUserChallengeActivitiesError,
  resetUserChallengeActivities: resetUserChallengeActivities,
  loadUserChallengeActions: loadUserChallengeActions,
  loadUserChallengeActionsSuccess: loadUserChallengeActionsSuccess,
  loadUserChallengeActionsError: loadUserChallengeActionsError,
  resetUserChallengeActions: resetUserChallengeActions,
  loadUserGroupChallengeStats: loadUserGroupChallengeStats,
  loadUserGroupChallengeStatsError: loadUserGroupChallengeStatsError,
  loadUserGroupChallengeStatsSuccess: loadUserGroupChallengeStatsSuccess,
  resetUserGroupChallengeStats: resetUserGroupChallengeStats
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map